import dispatcher from '../dispatcher';
import popupStore from '../popup/popup.store';

var elementProto = Object.create(HTMLButtonElement.prototype);

var _handleClick = function() {
	var element;
	var target = this.getAttribute('data-target');

	if (target) {
		element = this.querySelector(target);
	} else {
		element = this;
	}

	dispatcher.dispatch({
		type: 'popup:close',
		element: element
	});
}

elementProto.createdCallback = function() {
	this.handleClick = _handleClick.bind(this);
}
elementProto.attachedCallback = function() {
	this.addEventListener('click', this.handleClick);
}
elementProto.detachedCallback = function() {
	this.removeEventListener('click', this.handleClick);
}

document.registerElement('popup-close', {
	extends: 'button',
	prototype: elementProto
});

export default elementProto;